<template>
  <div class="register-page">
    <rhcn-drawer title="message.user.registerTitle" description="message.user.registerDesc" :showClose="false">
      <template slot="headerRight">
        <div class="register-header-right"><span>{{ $t('message.user.alreadyAccount') }}？</span><span class="link"
            @click="handleLogin">{{ $t('message.user.login') }}</span></div>
      </template>
      <div class="register-step-box"></div>
      <div class="form">
        <el-form ref="formRef" class="register-form" :model="form" :rules="formRules">
          <el-form-item :label="$t('message.user.email')" prop="email">
            <el-input v-model="form.email"
              :placeholder="$t('message.validator.input', { input: $t('message.user.email').toLowerCase() })"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.user.emailCode')" prop="emailCode">
            <div class="captcha-box">
              <el-input class="captcha-input" v-model="form.emailCode"
                :placeholder="$t('message.validator.input', { input: $t('message.user.emailCode').toLowerCase() })"></el-input>
              <el-button v-loading="requestingEmailCode" class="btn-captcha" @click="sendEmailCode">{{ emailCodeLeftTime
                > 0 ?
                `${emailCodeLeftTime}s` : $t('message.user.sendCaptcha') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('message.user.loginPassword')" prop="password">
            <el-popover placement="right" popper-class="password-popper" trigger="click">
              <template #reference>
                <el-input v-model="form.password" type="password" autocomplete="off" show-password maxlength="20"
                  :placeholder="$t('message.validator.input', { input: $t('message.user.loginPassword').toLowerCase() })"
                  @input="hanldePasswordInput">
                </el-input>
              </template>
              <div class="password-popper-content">
                <div>
                  <span class="margin-right-9">{{ $t('message.user.passwordStrength') }}</span>
                  <span class="password-strength-1" :class="[passwordStrength > 0 ? 'active' : '']"></span>
                  <span class="password-strength-2" :class="[passwordStrength > 1 ? 'active' : '']"></span>
                  <span class="password-strength-3" :class="[passwordStrength > 2 ? 'active' : '']"></span>
                  <span class="margin-left-9">{{ passwordStrengthMap[passwordStrength] || '' }}</span>
                </div>
                <div v-for="(item, index) in passwordRule" class="password-popper-item" :key="index">
                  <span class="password-popper-item-txt">{{ item.label }}</span>
                  <span class="password-popper-item-status"
                    :class="{ 'el-icon-check': item.status === 'success', 'el-icon-close': item.status === 'error' }"></span>
                </div>
              </div>
            </el-popover>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input v-model="form.confirmPassword" type="password" autocomplete="off" show-password maxlength="50"
              :placeholder="$t('message.validator.confirm', { confirm: $t('message.user.loginPassword').toLowerCase() })"></el-input>
          </el-form-item>
        </el-form>
        <div class="agreement-box margin-top-30">
          <el-checkbox v-model="checked"></el-checkbox>
          <span class="margin-left-12">{{ $t('message.user.readAgree') }}</span>
          <span class="link margin-left-4" @click="openAgreement">{{ $t('message.user.privacy1') }}</span>
        </div>
        <div class="margin-top-20">
          <el-button :loading="loading" style="width: 100%" type="primary" @click="onSubmit">{{
            $t("message.user.register")
            }}</el-button>
        </div>
        <div class="register-form-bottom">
          <div class="form-bottom-left">
            <span class="pointer" @click="openAgreement">{{ $t('message.user.privacy') }}</span>
          </div>
          <div class="form-bottom-right">
            <span class="pointer" @click="setLanguage('zh-cn')">中文</span>
            <span class="split"></span>
            <span class="pointer" @click="setLanguage('en')">English</span>
          </div>
        </div>
      </div>
    </rhcn-drawer>
  </div>
</template>
<script>
import { sendEmailCaptcha, registerMerchant } from '@/api/common/user';
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import {
  REQUIRED,
  VALIDATE_PASSWORD,
  PASSWORD_LENGTH,
  PASSWORD_STRENGTH,
  EMAIL,
} from '@/components/validation/tool/validator';
import { setI18nLanguage } from '@/language';
import PacypayCookie from '@/utils/cookie-consent/cookie';

export default {
  components: {
    RhcnDrawer,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',

        confirmPassword: '',
        emailCode: '',
      },
      formRules: this.getFormRules(),
      loading: false,
      emailCodeLeftTime: 0,
      emailTimer: null,
      checked: false,
      passwordRule: [{
        label: this.$t('message.validator.passwordLength'),
        status: '',
      }, {
        label: this.$t('message.validator.passwordStrength'),
        status: '',
      }],
      passwordStrength: 0,
      passwordStrengthMap: {
        1: this.$t('message.user.weak'),
        2: this.$t('message.user.medium'),
        3: this.$t('message.user.strong'),
      },
      steps: [
        {
          title: 'message.user.register',
        },
        {
          title: 'message.user.supplement',
        },
        {
          title: 'message.user.approving',
        },
        {
          title: 'message.common.finish',
        },
      ],
      agreementUrl: 'https://www.onerway.com/privacy',
      requestingEmailCode: false,
    };
  },
  created() {
  },
  methods: {
    onSubmit() {
      if (!this.checked) {
        ShowWarningMessage(this.$t('message.user.agreementTips'));
        return;
      }
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const { email, password, emailCode } = this.form;
          const params = {
            businessType: '0',
            registerEmail: email.trim(),
            emailCode: emailCode.trim(),
            password: password.trim(),
            protocolInfo: {
              '01': this.agreementUrl,
            },
          };
          this.loading = true;
          try {
            await registerMerchant(params);
            this.$router.replace({ path: '/user/register/done' });
          } catch (err) {

          }
          this.loading = false;
        }
      });
    },
    async sendEmailCode() {
      if (this.emailCodeLeftTime > 0 || this.requestingEmailCode) {
        return;
      }
      const email = this.form.email.trim();
      if (!email) {
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.email') }));
        return;
      }

      this.requestingEmailCode = true;
      try {
        const lang = this.$store.getters.app.currentLan;
        const language = lang === 'zh-cn' ? 'zh' : lang;
        await sendEmailCaptcha({
          email,
          language,
        });
        if (this.emailTimer) {
          clearInterval(this.emailTimer);
        }

        this.emailCodeLeftTime = 59;
        this.emailTimer = setInterval(() => {
          this.emailCodeLeftTime -= 1;
          if (this.emailCodeLeftTime <= 0) {
            clearInterval(this.emailTimer);
            this.emailTimer = null;
          }
        }, 1000);
      } catch (err) {

      }
      this.requestingEmailCode = false;
    },
    openAgreement() {
      const lang = this.$store.getters.app.currentLan;
      const language = lang === 'zh-cn' ? 'zh' : lang;
      window.open(`${this.agreementUrl}?lang=${language}`, '_blank');
    },
    getFormRules() {
      const validateEmail = (rule, value, callback) => {
        // 必填验证
        if (REQUIRED.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.email').toLowerCase() })));
          return;
        }
        // 邮箱格式验证
        if (!EMAIL.regExp.test(value)) {
          callback(new Error(this.$t(EMAIL.tips)));
          return;
        }
        callback();
      };
      const validatePassword = (rule, value, callback) => {
        // 必填验证
        if (REQUIRED.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.loginPassword').toLowerCase() })));
          return;
        }
        // 密码格式验证
        if (!VALIDATE_PASSWORD.regExp.test(value)) {
          callback(new Error(this.$t(VALIDATE_PASSWORD.tips)));
          return;
        }
        if (!PASSWORD_LENGTH.regExp.test(value)) {
          callback(new Error(this.$t(PASSWORD_LENGTH.tips)));
          return;
        }
        if (!PASSWORD_STRENGTH.regExp.test(value)) {
          callback(new Error(this.$t(PASSWORD_STRENGTH.tips)));
          return;
        }
        callback();
      };
      const validateConfirmPassword = (rule, value, callback) => {
        // 必填验证
        if (REQUIRED.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.confirm', { confirm: this.$t('message.user.loginPassword').toLowerCase() })));
          return;
        }
        if (this.form.password !== value) {
          callback(new Error(this.$t('message.validator.passwordDiff')));
          return;
        }
        callback();
      };
      const validateRequired = (rule, value, callback) => {
        // 必填验证
        if (REQUIRED.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.required')));
          return;
        }
        callback();
      };
      return {
        email: [
          { validator: validateEmail, trigger: 'blur' },
        ],
        emailCode: [
          { validator: validateRequired, trigger: 'blur' },
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' },
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' },
        ],
      };
    },
    hanldePasswordInput(value) {
      // 密码小于8位或者单一元素（仅包含字母、仅包含数字、仅包含字符）时为弱
      // 包含数字+字符+字母，字母仅有大写（或者仅有小写）时为中
      // 包含数字+字符+字母，字母包含大小写时为强
      if (!value) {
        this.passwordStrength = 0; // 不显示
      } else if (value.length >= 8 && PASSWORD_STRENGTH.regExp.test(value)) {
        // 符合条件，判断密码强度：中/强
        if (/[A-Z]/g.test(value) && /[a-z]/g.test(value)) {
          // 包含大小写，则为强
          this.passwordStrength = 3;
        } else {
          this.passwordStrength = 2;
        }
        this.passwordRule[1].status = 'success';
      } else { // 不符合的都是弱密码
        this.passwordStrength = 1;
        this.passwordRule[1].status = 'error';
      }

      if (value.length >= 8) {
        this.passwordRule[0].status = 'success';
      } else {
        this.passwordRule[0].status = 'error';
      }
    },
    handleLogin() {
      this.$router.replace({ path: '/user/login' });
    },
    setLanguage(lang) {
      setI18nLanguage(lang, this.$i18n);
      if (window.pCookie) {
        window.pCookie.unmount();
        // eslint-disable-next-line no-undef
        window.pCookie = new PacypayCookie({
          policyUrl: lang === 'zh-cn' ? '/static/files/cookie-zh.html' : '/static/files/cookie.html',
          locale: lang,
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/element-variables.scss';

.register-page {
  .drawer-form-wrapper .form {
    width: 450px;
  }

  .register-step-box {
    width: 580px;
    margin: 10px auto;
    margin-bottom: 40px;
  }

  .register-form {
    ::v-deep .el-form-item {
      margin-bottom: 25px;
    }

    ::v-deep .el-form-item .el-form-item__label {
      line-height: 32px;
      font-weight: 600;
    }
  }

  .register-form-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    line-height: 34px;
    margin-top: 20px;

    .form-bottom-left {
      font-family: Avenir-Book, Avenir;
      font-weight: 400;
      color: #264373;
    }

    .form-bottom-right {
      display: flex;
      align-items: center;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 500;
      color: #1C4377;

      .split {
        display: inline-block;
        width: 1px;
        height: 13px;
        background-color: #1C4377;
        margin: 0 10px;
      }
    }

    .pointer {
      cursor: pointer;
    }
  }

  ::v-deep .text-wrapper {
    width: auto;

    .tip {
      margin-top: 0;
    }
  }

  .captcha-box {
    width: 100%;
    display: flex;
    align-content: center;

    .captcha-input {
      flex: 1;
      margin-right: 12px;
    }

    .btn-captcha {
      min-width: 120px;
      height: 44px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .agreement-box {
    display: flex;
    align-content: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 20px;

    .link {
      color: $color-text-default-button;
      cursor: pointer;
    }
  }

  .register-header-right {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    color: $color-text-primary;
    line-height: 28px;

    .link {
      color: $color-primary;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
@import '@/styles/element-variables.scss';

.password-popper {
  width: 325px;
  box-sizing: border-box;

  .password-popper-content {
    font-size: 14px;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 32px;

    .password-strength-1 {
      display: inline-block;
      width: 30px;
      height: 10px;
      background: #D8D8D8;
      border-radius: 100px 0px 0px 100px;

      &.active {
        background: #FFDB8B;
      }
    }

    .password-strength-2 {
      display: inline-block;
      width: 30px;
      height: 10px;
      background: #D8D8D8;
      margin: 0 2px;

      &.active {
        background: #ACE59E;
      }
    }

    .password-strength-3 {
      display: inline-block;
      width: 30px;
      height: 10px;
      background: #D8D8D8;
      border-radius: 0px 100px 100px 0px;

      &.active {
        background: #70D358;
      }
    }
  }

  .password-popper-item {
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 16px;

    &::before {
      position: absolute;
      content: '';
      width: 6px;
      height: 3px;
      background: $color-text-primary;
      left: 0;
      top: 14px;
    }

    .password-popper-item-txt {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 32px;
    }

    .password-popper-item-status {
      font-weight: 600;

      &.el-icon-close {
        color: #FF8585;
      }

      &.el-icon-check {
        color: #70D358;
      }
    }
  }
}
</style>
